import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// PrimeNG Modules
import { AvatarModule } from 'primeng/avatar';
import { SidebarModule } from 'primeng/sidebar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { StepsModule } from 'primeng/steps';

// Layout and Common Modules
import { LayoutsModule } from './layouts/layouts.module';
import { CommonComponentsModule } from './common/common.module';
import { PipesModule } from './pipes/pipes.module';

// UI Component Modules
import { CardComponentModule } from './common/ui/card/card-component.module';
import { ToasterComponentModule } from './common/ui/toaster/toaster-component.module';
import { ButtonComponentModule } from './common/ui/button/button-component.module';
import { AutoCompleteComponentModule } from './common/ui/auto-complete/auto-complete.module';
import { TabComponentModule } from './common/ui/tab/tab-component.module';
import { TableComponentModule } from './common/ui/table/table-component.module';
import { InputComponentModule } from './common/ui/input/input-component.module';
import { LoaderComponentModule } from './common/ui/loader/loader-component.module';
import { RadioComponentModule } from './common/ui/radio/radio-component.module';
import { SelectComponentModule } from './common/ui/select/select-component.module';
import { AccordianComponentModule } from './common/ui/accordian/accordian-component.module';
import { CheckboxComponentModule } from './common/ui/checkbox/checkbox-component.module';
import { BadgeComponentModule } from './common/ui/badge/badge-component.module';
import { PanelComponentModule } from './common/ui/panel/panel-component.module';
import { InputTextareaComponentModule } from './common/ui/input-textarea/input-textarea-component.module';
import { ChartsComponentModule } from './common/ui/charts/charts-component.module';
import { InputSwitchComponentModule } from './common/ui/input-switch/input-switch-component.module';
import { EditorComponentModule } from './common/ui/editor/editor-component.module';
import { CircleProgressComponentModule } from './common/ui/circle-progress/circle-progress.module';
import { CustomImageCropperModule } from './common/ui/image-cropper/image-cropper.module';
import { PaginatorComponentModule } from './common/ui/paginator/paginator.module';
import { TypographyComponentModule } from './common/ui/typography/typography.module';
import { MenuComponentModule } from './common/ui/menu/menu.module';
import { RatingComponentModule } from './common/ui/rating/rating-component.module';
import { ModalComponentModule } from './common/ui/modal/modal-component.module';
import { ProgressBarComponentModule } from './common/ui/progress-bar/progress-bar.module';
import { ChipComponentModule } from './common/ui/chip/chip-component.module';
import { CalendarComponentModule } from './common/ui/calendar/calendar-component.module';
import { HeaderButtonComponentModule } from './common/ui/header-button/header-button-component.module';
import { ConfirmDialogComponentModule } from './common/ui/confim-dialog/confirm-dialog-component.module';
import { CircularProgressBarComponentModule } from './common/ui/circular-progressbar/circular-progressbar-component.module';
import { NewRadioComponentModule } from './common/ui/new-radio/radio-component.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    
    // PrimeNG
    AvatarModule,
    SidebarModule,
    PanelMenuModule,
    StepsModule,
    
    // Layout and Common Modules
    LayoutsModule,
    CommonComponentsModule,
    PipesModule,
    
    // UI Component Modules
    CardComponentModule,
    ToasterComponentModule,
    ButtonComponentModule,
    AutoCompleteComponentModule,
    TabComponentModule,
    TableComponentModule,
    InputComponentModule,
    LoaderComponentModule,
    RadioComponentModule,
    NewRadioComponentModule,
    SelectComponentModule,
    AccordianComponentModule,
    CheckboxComponentModule,
    BadgeComponentModule,
    PanelComponentModule,
    InputTextareaComponentModule,
    ChartsComponentModule,
    InputSwitchComponentModule,
    EditorComponentModule,
    CircleProgressComponentModule,
    CustomImageCropperModule,
    PaginatorComponentModule,
    TypographyComponentModule,
    MenuComponentModule,
    RatingComponentModule,
    ModalComponentModule,
    ProgressBarComponentModule,
    ChipComponentModule,
    CalendarComponentModule,
    HeaderButtonComponentModule,
    ConfirmDialogComponentModule,
    CircularProgressBarComponentModule
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    
    // PrimeNG
    AvatarModule,
    SidebarModule,
    PanelMenuModule,
    StepsModule,
    
    // Layout and Common Modules
    LayoutsModule,
    CommonComponentsModule,
    PipesModule,
    
    // UI Component Modules
    CardComponentModule,
    ToasterComponentModule,
    ButtonComponentModule,
    AutoCompleteComponentModule,
    TabComponentModule,
    TableComponentModule,
    InputComponentModule,
    LoaderComponentModule,
    RadioComponentModule,
    SelectComponentModule,
    AccordianComponentModule,
    CheckboxComponentModule,
    BadgeComponentModule,
    PanelComponentModule,
    InputTextareaComponentModule,
    ChartsComponentModule,
    InputSwitchComponentModule,
    EditorComponentModule,
    CircleProgressComponentModule,
    CustomImageCropperModule,
    PaginatorComponentModule,
    TypographyComponentModule,
    MenuComponentModule,
    RatingComponentModule,
    ModalComponentModule,
    ProgressBarComponentModule,
    ChipComponentModule,
    CalendarComponentModule,
    HeaderButtonComponentModule,
    ConfirmDialogComponentModule,
    CircularProgressBarComponentModule
  ]
})
export class SharedModule { }